import React from 'react';
import { useHistory, useLocation } from 'react-router';
import * as MUI from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { StyledBackButton } from './BackButton.style';
import { BackButtonProps } from './BackButton.type';
import { canGoBack, getParentPath } from './BackButton.utils';

export const BackButton = (props: BackButtonProps) => {
  const { backToPath, size = "small", ...btnProps } = props;
  const history = useHistory();
  const location = useLocation();

  const handleClick = React.useCallback(() => {
    if (backToPath) {
      history.push(backToPath);
    } else if (canGoBack()) {
      history.goBack();
    } else {
      history.replace(getParentPath(location));
    }
  }, [backToPath, location]);

  return (
    <MUI.Tooltip title={"Back"}>
      <StyledBackButton size={size} {...btnProps} onClick={handleClick}>
        <ArrowBackIcon />
      </StyledBackButton>
    </MUI.Tooltip>
  )
};
